import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import Storage from '@aws-amplify/storage';
console.log("-->" + process.env.VUE_APP_BUCKET_NAME);
Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    // identityPoolId: ‘XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab’,
    // REQUIRED - Amazon Cognito Region
    region: process.env.VUE_APP_COGNITO_REGION,
    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it’s different from Amazon Cognito Region
    identityPoolRegion: process.env.VUE_APP_COGNITO_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,

    identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID
  },
  Storage: {
    bucket: process.env.VUE_APP_BUCKET_NAME,
    region: process.env.VUE_APP_COGNITO_REGION,
    identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID
  }
});
Storage.configure(
  {
    bucket: process.env.VUE_APP_BUCKET_NAME,//Your bucket name;
    region: process.env.VUE_APP_COGNITO_REGION,
    identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
  }
);

// You can get the current config object
const currentConfig = Auth.configure();
export default currentConfig;

// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// const awsmobile = {
//     "aws_project_region": "us-east-2",
//     "aws_appsync_graphqlEndpoint": "https://46lnimvklvdebbuoaoy4npyfuu.appsync-api.us-east-2.amazonaws.com/graphql",
//     "aws_appsync_region": "us-east-2",
//     "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
//     "aws_cognito_identity_pool_id": "us-east-2:56bab403-f1e2-48bb-a948-0cb0fade6a47",
//     "aws_cognito_region": "us-east-2",
//     "aws_user_pools_id": "us-east-2_DdGoZtyOI",
//     "aws_user_pools_web_client_id": "3too2pmnjl3q3nhh3oau4kktlc",
//     "oauth": {}
// };

// export default awsmobile;